import React, {useEffect} from "react";
import useAuth from "./use-auth";

const AuthRequired = (props: any) => {
    const {children} = props;
    const auth : any = useAuth();
    const token = auth.token;

    useEffect(() => {
        auth.checkAuth();
    });

    if (token) {
        return children;
    } else {
        return '';
    }
}

export default AuthRequired;
